module.exports = __webpack_public_path__ + "img/banner-18.fed32d92.jpg";